module.exports = __webpack_public_path__ + "img/is-set.5a47cc70.svg";